import React, { use } from "react";
import type { Maybe } from "@entrilia/shared/types";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { TileObject } from "../models/TileObject";

export interface CurrentTileContextType {
  tile: TileObject;
  hover?: Maybe<boolean>;
}

export const CurrentTileContext = React.createContext<CurrentTileContextType | undefined>(undefined);

export const useCurrentTileContext = () => {
  const context = use(CurrentTileContext);
  return defined(context);
};
